import { defaultsDeep } from 'lodash';
import { overrideConfig } from './override.config';

export interface Config {
  title: string;
  port: number;
  footer: {
    text: string;
  };
  firebase: {
    apiKey: string;
    authDomain: string;
    databaseURL: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
  base: {
    webUrl: string;
    apiUrl: string;
    baseUrl: string;
    uploadEndpoint: string;
    imageEndpoint: string;
    rootEndpoint: string;
    templateSource: string;
  };
  identity: {
    url: string;
  };
  googleAnalytics: {
    measurementId: string;
  };
  analytics: {
    appName: string;
  };
  powerbiUrl: {
    link: string;
    group: string;
    report: string;
  };
  regex: {
    username: RegExp;
    email: RegExp;
    phone: RegExp;
    password: RegExp;
    url: RegExp;
  };
  i18n: {
    VI: string;
    EN: string;
    defaultLang: string;
  };
  monitoring: {
    appInsightsConnectionString: string;
  };
  posthog: {
    enabled: boolean;
    apiKey: string;
    apiHost: string;
  };
  socketService: { main: string; url: string };
  allowRedirectWithSessionHash: string[];
}

const defaultConfig: Config = {
  title: 'MindX Technology School',
  port: 3006,
  footer: {
    text: 'MindX Technology School 2022',
  },
  firebase: {
    apiKey: 'AIzaSyB-x8gFuVKzbIoB1aYKbG1jrvm8mbZUmkQ',
    authDomain: 'mindx-edu-dev.firebaseapp.com',
    databaseURL: 'https://mindx-edu-dev.firebaseio.com',
    projectId: 'mindx-edu-dev',
    storageBucket: 'mindx-edu-dev.appspot.com',
    messagingSenderId: '592744290445',
    appId: '1:592744290445:web:aa82213d363f9b59c5eac4',
    measurementId: 'G-QPEELWB8Q4',
  },
  base: {
    webUrl: 'https://base-dev.mindx.edu.vn',
    apiUrl: 'https://base-api-dev.mindx.edu.vn',
    baseUrl: 'https://base-api-dev.mindx.edu.vn',
    rootEndpoint: 'https://resources-dev.mindx.edu.vn',
    uploadEndpoint: 'https://resources-dev.mindx.edu.vn/api/v1/resources',
    imageEndpoint: 'https://resources-dev.mindx.edu.vn/uploads/images',
    templateSource: '/uploads/documents/File update TMS -1723549263903-3516.xlsx',
  },
  identity: {
    url: 'https://id-dev.mindx.edu.vn',
  },
  googleAnalytics: {
    measurementId: 'G-MCRC3T5CRN',
  },
  analytics: {
    appName: 'mindx-web-base',
  },
  powerbiUrl: {
    link: 'app.powerbi.com',
    group: 'groups',
    report: 'report',
  },
  regex: {
    username: /^[a-zA-Z0-9\-.]{5,50}$/,
    email: /^[a-z0-9][a-z0-9_.]{0,40}@[a-z0-9]{2,}(.[a-z0-9]{2,4}){1,2}$/,
    phone: /^(\+84)([0-9]){9}$/,
    password: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,20}$/,
    url: new RegExp(
      [
        'https?://',
        '([a-zA-Z0-9-]+.)?',
        '(mindx.edu.vn|mindx.vn|mindx.com.vn|mindxspace.com)',
        '(/[-a-zA-Z0-9()@:%_+.~#?&//=]*)?',
      ].join(''),
    ),
  },
  socketService: {
    main: 'ws://localhost:30916',
    url: 'wss://noti-dev.mindx.edu.vn',
  },
  monitoring: {
    appInsightsConnectionString:
      'InstrumentationKey=f497f313-5d0d-480b-a217-10e7e09dfdac;IngestionEndpoint=https://southeastasia-1.in.applicationinsights.azure.com/;LiveEndpoint=https://southeastasia.livediagnostics.monitor.azure.com/;ApplicationId=ff04bca7-f470-4aad-bd33-9efe6f945c8b',
  },
  posthog: {
    enabled: true,
    apiKey: 'phc_DLHMLlobE7EXNeC7d3ctPTffzB6xe5kWixiYLjUiioJ',
    apiHost: 'https://us.i.posthog.com',
  },
  i18n: {
    VI: 'vi',
    EN: 'en',
    defaultLang: 'vi',
  },
  allowRedirectWithSessionHash: ['apps-dev.mindx.edu.vn', 'apps.mindx.edu.vn'],
};

export const config = defaultsDeep(overrideConfig, defaultConfig) as Config;
